import { useInfiniteQuery } from '@tanstack/react-query'
import { customerService } from '../services/customerService'

const CUSTOMERS_QUERY_KEY = 'customers'

export function useInfiniteCustomers(filters?: Record<string, unknown>) {
  return useInfiniteQuery({
    queryKey: [CUSTOMERS_QUERY_KEY, 'infinite', filters],
    queryFn: ({ pageParam = 1 }) =>
      customerService.searchCustomers({
        ...filters,
        page: pageParam,
        limit: (filters?.limit as number) || 50,
      }),
    getNextPageParam: (lastPage, _pages) => {
      if (lastPage.pagination.has_next) {
        return lastPage.pagination.page + 1
      }
      return undefined
    },
    initialPageParam: 1,
  })
}
